<script setup lang="ts">
import { RouterLink } from 'vue-router'

import PageHeader from '#shared/components/PageHeader.vue'
import { Button } from '#ui/button'

definePage({
  meta: { requiresAuth: true, title: 'Page not found' },
})
</script>

<template>
  <PageHeader
    title="Page not found"
    description="That page doesn't exist, or it moved. Pick a section from the sidebar, or head back to the dashboard."
  >
    <template #actions>
      <Button as-child>
        <RouterLink to="/">Back to dashboard</RouterLink>
      </Button>
    </template>
  </PageHeader>
</template>
